import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledSettingsListItem = styled(Grid)(({ theme }) => ({
  width: "100%",
  borderBottom: "1px solid #adadad",
  padding: theme.spacing(2, 0),
})) as typeof Grid;
